module.exports = __webpack_public_path__ + "img/80 overflow-hidden.0590e61c.png";